interface StateType {
    mainBackground: string;
    shopBackground: string;
    mainTab1: string;
    mainTab2: string;
    mainTab3: string;
    topBackground: string;
    bottomBackground: string;
    middleBackground: string;
    rankBackground: string;
    tab1: string;
    tab2: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        tab1: '',
        tab2: '',
        mainTab1: '',
        mainTab2: '',
        mainTab3: '',
        mainBackground: '',
        shopBackground: '',
        topBackground: '',
        bottomBackground: '',
        middleBackground: '',
        rankBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
